module.exports = __webpack_public_path__ + "img/THERMOSYSCS4.ad7e6540.jpg";